











import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class ErrorList extends Vue {
  @Prop({ type: Array, required: false }) private errorListText!: string[];
}
